import React from "react";
import "./style.css";
import Navbar from "../../Components/Navbar";

const Terms = () => {
  return (
    <>
      <Navbar />
      <div className="privacy-container">
        <div className="privacy-content">
          <h1 className="title">Terms &amp; Conditions</h1>
          <p className="last-updated">Last Updated: March 2026</p>

          <p>
            Please read these Terms and Conditions carefully before downloading
            or using the <strong>Status Saver</strong> app. By
            downloading, installing, or using the App, you agree to be bound by
            these Terms. If you do not agree with any part of these Terms,
            please do not use the App.
          </p>
          <p>
            These Terms constitute a legal agreement between you ("User", "you")
            and <strong>CouSync LLC</strong> ("we", "us", "our", "Company").
            These Terms govern your use of the{" "}
            <strong>
              Status Saver – Status Saver &amp; Downloader
            </strong>{" "}
            mobile application ("the App") and all related services.
          </p>

          <h2>1. Acceptance of Terms</h2>
          <p>By installing or using the App, you confirm that:</p>
          <ul>
            <li>
              You are at least 13 years of age (or the age of digital consent in
              your country)
            </li>
            <li>
              You have read, understood, and agree to be bound by these Terms
            </li>
            <li>You have the legal capacity to enter into a binding agreement</li>
            <li>
              You are not prohibited by any law or authority from using the App
            </li>
          </ul>
          <p>
            If you are using the App on behalf of an organization, you represent
            that you have the authority to bind that organization to these Terms.
          </p>

          <h2>2. About the App</h2>
          <p>
            Status Saver is a free utility application that allows
            users to view and save status media (photos, videos) that are stored
            in the local cache of messaging applications on their device. The
            App works entirely on-device and does not upload or transmit any
            media files to external servers.
          </p>
          <p>
            Status Saver is an independent application and is{" "}
            <strong>NOT</strong> affiliated with, endorsed by, sponsored by, or
            officially connected to WhatsApp LLC, Meta Platforms Inc., or any
            other third-party messaging platform. All trademarks, logos, and
            brand names are the property of their respective owners.
          </p>

          <h2>3. License to Use</h2>
          <p>
            Subject to your compliance with these Terms, we grant you a limited,
            revocable, non-exclusive, non-transferable, non-sublicensable
            license to:
          </p>
          <ul>
            <li>
              Download and install the App on your personal Android device
            </li>
            <li>
              Use the App solely for your own personal, non-commercial purposes
            </li>
          </ul>
          <p>This license does not include the right to:</p>
          <ul>
            <li>Copy, modify, or create derivative works of the App</li>
            <li>
              Reverse engineer, decompile, or attempt to extract the source code
              of the App
            </li>
            <li>
              Translate the App into other languages or make derivative versions
            </li>
            <li>
              Remove, alter, or obscure any copyright, trademark, or other
              proprietary notices
            </li>
            <li>
              Use the App for any commercial purpose or for any public display
            </li>
            <li>
              Sublicense, sell, rent, lease, transfer, or otherwise exploit the
              App
            </li>
          </ul>
          <p>
            All rights not expressly granted to you are reserved by us and our
            licensors.
          </p>

          <h2>4. Acceptable Use Policy</h2>
          <p>
            You agree to use the App only for lawful purposes and in a manner
            that does not infringe the rights of others. You must{" "}
            <strong>NOT</strong> use the App to:
          </p>
          <ul>
            <li>
              Save or distribute content without the permission of the original
              creator
            </li>
            <li>
              Violate any applicable local, national, or international law or
              regulation
            </li>
            <li>
              Infringe the intellectual property, privacy, or other rights of
              third parties
            </li>
            <li>Harass, abuse, threaten, or harm any individual</li>
            <li>Distribute malware, viruses, or any other harmful code</li>
            <li>
              Attempt to gain unauthorized access to any system or network
            </li>
            <li>
              Use the App in any way that could damage, overload, or impair its
              functionality
            </li>
            <li>
              Circumvent, disable, or interfere with any security features of
              the App
            </li>
          </ul>
          <p>
            We reserve the right to terminate your access to the App if you
            violate these acceptable use standards.
          </p>

          <h2>5. Content and Copyright</h2>

          <h3>5.1 Third-Party Content</h3>
          <p>
            The App enables you to access media files that are temporarily
            stored on your own device by messaging applications. This media is
            created by third parties (your contacts). You acknowledge that:
          </p>
          <ul>
            <li>
              All media content visible through the App belongs to its original
              creator
            </li>
            <li>
              We do not own, control, or take responsibility for any
              third-party content
            </li>
            <li>
              We have not reviewed, approved, or verified any content accessible
              through the App
            </li>
          </ul>

          <h3>5.2 Your Responsibility</h3>
          <p>
            You are solely responsible for how you use the App and any content
            you save or share through it. You agree to:
          </p>
          <ul>
            <li>
              Only save status content with the explicit permission of the
              original creator
            </li>
            <li>
              Respect the intellectual property and privacy rights of all
              content creators
            </li>
            <li>
              Not save, copy, share, or distribute content without proper
              authorization
            </li>
            <li>
              Comply with all applicable copyright and intellectual property laws
            </li>
          </ul>
          <p>
            We strongly discourage saving or sharing any content without the
            consent of the original creator.
          </p>

          <h3>5.3 Copyright Infringement</h3>
          <p>
            If you believe that any content accessible through the App infringes
            your intellectual property rights, please contact us immediately at{" "}
            <strong>contact@cousync.com</strong> with full details of your
            claim. We take copyright claims seriously and will respond promptly.
          </p>

          <h2>6. Third-Party Services</h2>
          <p>
            The App uses the following third-party services which are governed
            by their own separate terms and conditions:
          </p>
          <ul>
            <li>
              Google Play Services —{" "}
              <a
                href="https://policies.google.com/terms"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://policies.google.com/terms
              </a>
            </li>
            <li>
              AdMob (Advertising) —{" "}
              <a
                href="https://support.google.com/admob/answer/6128543"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://support.google.com/admob/answer/6128543
              </a>
            </li>
            <li>
              Google Analytics for Firebase —{" "}
              <a
                href="https://firebase.google.com/policies/analytics"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://firebase.google.com/policies/analytics
              </a>
            </li>
            <li>
              Firebase Crashlytics —{" "}
              <a
                href="https://firebase.google.com/support/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://firebase.google.com/support/privacy
              </a>
            </li>
          </ul>
          <p>
            We are not responsible for the terms, policies, or practices of
            these third-party services. The App may contain links to
            third-party websites or services. We have no control over and
            assume no responsibility for the content, privacy policies, or
            practices of any third-party sites or services.
          </p>

          <h2>7. Advertisements</h2>
          <p>
            The free version of Status Saver may display advertisements
            provided by third-party advertising networks including Google AdMob.
            By using the App, you consent to the display of advertisements.
          </p>
          <p>
            We are not responsible for the content of advertisements displayed
            in the App. Advertisement content is determined by third-party
            advertising networks based on their own policies and your device
            settings.
          </p>
          <p>
            You may opt out of personalized advertising through your device
            settings (Settings &gt; Google &gt; Ads &gt; Opt out of Ads
            Personalization).
          </p>

          <h2>8. Device and Internet Requirements</h2>
          <p>
            The App requires an Android device with sufficient storage and may
            require an internet connection for certain features (such as loading
            advertisements and crash reporting). The core functionality of saving
            status media works offline.
          </p>
          <p>You are responsible for:</p>
          <ul>
            <li>
              Ensuring your device meets the minimum requirements to run the App
            </li>
            <li>
              Maintaining a sufficient data plan if using mobile internet
            </li>
            <li>
              Any charges imposed by your mobile network provider for data usage
            </li>
            <li>
              Any roaming charges if using the App outside your home country
            </li>
            <li>Keeping your device charged and operational</li>
          </ul>
          <p>
            We are not responsible for the App not functioning properly due to
            lack of internet connectivity, insufficient device storage, or
            incompatible device software.
          </p>

          <h2>9. Device Security</h2>
          <p>
            We strongly recommend that you do not jailbreak or root your device.
            Jailbreaking or rooting removes the software restrictions imposed by
            your device's official operating system and may:
          </p>
          <ul>
            <li>
              Make your device vulnerable to malware, viruses, and malicious
              programs
            </li>
            <li>Compromise your device's security features</li>
            <li>Cause the App to malfunction or not work at all</li>
            <li>Void your device warranty</li>
          </ul>
          <p>
            We cannot be held responsible for any damage, data loss, or security
            breach resulting from the use of a jailbroken or rooted device.
          </p>

          <h2>10. Updates and Changes</h2>
          <p>
            We reserve the right to update, modify, or discontinue the App or
            any part of it at any time, with or without notice, and without
            liability to you. Updates may be installed automatically on your
            device.
          </p>
          <p>
            We do not guarantee that the App will always be updated to remain
            compatible with the Android version installed on your device.
            However, we will make reasonable efforts to maintain compatibility
            with supported Android versions.
          </p>
          <p>
            Continued use of the App after any updates constitutes your
            acceptance of the revised App and these Terms.
          </p>

          <h2>11. Termination</h2>
          <p>These Terms remain in effect until terminated by either you or us.</p>

          <h3>11.1 Termination by You</h3>
          <p>
            You may terminate these Terms at any time by uninstalling and
            deleting the App from your device.
          </p>

          <h3>11.2 Termination by Us</h3>
          <p>
            We may suspend or terminate your access to the App at any time, with
            or without cause, and with or without notice, if we believe you have
            violated these Terms or applicable laws. Upon termination:
          </p>
          <ul>
            <li>
              All rights and licenses granted to you under these Terms will
              immediately end
            </li>
            <li>You must stop using the App and delete it from your device</li>
            <li>
              Provisions that by their nature should survive termination will
              remain in effect
            </li>
          </ul>

          <h2>12. Disclaimer of Warranties</h2>
          <p>
            THE APP IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT
            WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
            LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE, NON-INFRINGEMENT, OR TITLE.
          </p>
          <p>We do not warrant that:</p>
          <ul>
            <li>
              The App will be error-free, uninterrupted, or free from bugs or
              viruses
            </li>
            <li>
              The App will meet your specific requirements or expectations
            </li>
            <li>Any errors or defects in the App will be corrected</li>
            <li>
              The results obtained from the use of the App will be accurate or
              reliable
            </li>
          </ul>
          <p>
            YOUR USE OF THE APP IS ENTIRELY AT YOUR OWN RISK AND RESPONSIBILITY.
          </p>

          <h2>13. Limitation of Liability</h2>
          <p>
            TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, COUSYNC LLC, ITS
            AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS SHALL NOT BE
            LIABLE FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL,
            PUNITIVE, OR EXEMPLARY DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF
            PROFITS, LOSS OF DATA, LOSS OF GOODWILL, BUSINESS INTERRUPTION, OR
            ANY OTHER INTANGIBLE LOSSES, ARISING OUT OF OR IN CONNECTION WITH:
          </p>
          <ul>
            <li>Your use of or inability to use the App</li>
            <li>
              Any content saved, shared, or distributed through the App
            </li>
            <li>
              Any unauthorized access to or use of your device or data
            </li>
            <li>Any errors or inaccuracies in the App</li>
            <li>
              Any third-party content, services, or advertisements
            </li>
          </ul>
          <p>
            OUR TOTAL AGGREGATE LIABILITY TO YOU FOR ANY CLAIMS ARISING UNDER
            THESE TERMS SHALL NOT EXCEED THE AMOUNT YOU PAID US IN THE TWELVE
            (12) MONTHS PRECEDING THE CLAIM, OR $50 USD, WHICHEVER IS LESS.
          </p>

          <h2>14. Indemnification</h2>
          <p>
            You agree to defend, indemnify, and hold harmless CouSync LLC and
            its affiliates, officers, directors, employees, and agents from and
            against any claims, damages, losses, liabilities, costs, and
            expenses (including reasonable legal fees) arising from or related
            to:
          </p>
          <ul>
            <li>Your use of or inability to use the App</li>
            <li>Your violation of these Terms</li>
            <li>Your violation of any applicable law or regulation</li>
            <li>
              Your infringement of any intellectual property or other rights of
              any third party
            </li>
            <li>
              Any content you save, share, or distribute through the App
            </li>
          </ul>

          <h2>15. Children's Privacy</h2>
          <p>
            The App is not intended for use by children under the age of 13. We
            do not knowingly collect personal information from children under 13.
            If you are a parent or guardian and believe your child is using the
            App or has provided us with personal information, please contact us
            immediately at <strong>contact@cousync.com</strong>. We will take
            appropriate steps to remove such information and restrict access.
          </p>

          <h2>16. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with
            applicable laws. Any disputes arising from these Terms or your use
            of the App shall be resolved through good-faith negotiation between
            the parties. If negotiation fails, disputes shall be subject to the
            exclusive jurisdiction of the competent courts in the applicable
            jurisdiction.
          </p>

          <h2>17. Changes to These Terms</h2>
          <p>
            We reserve the right to update or modify these Terms at any time.
            When we make changes, we will update the "Last Updated" date at the
            top of this document. For material changes, we will make reasonable
            efforts to notify you through the App or via a Play Store
            notification.
          </p>
          <p>
            Your continued use of the App after any changes to these Terms
            constitutes your acceptance of the revised Terms. If you do not
            agree with the updated Terms, you must stop using the App and
            uninstall it from your device.
          </p>

          <h2>18. Severability</h2>
          <p>
            If any provision of these Terms is found to be invalid, illegal, or
            unenforceable by a court of competent jurisdiction, that provision
            shall be modified to the minimum extent necessary to make it
            enforceable, or if modification is not possible, it shall be severed
            from these Terms. The remaining provisions shall continue in full
            force and effect.
          </p>

          <h2>19. Entire Agreement</h2>
          <p>
            These Terms, together with our{" "}
            <a href="/privacy-policy">Privacy Policy</a> (incorporated herein by
            reference), constitute the entire agreement between you and us
            regarding the App and supersede all prior agreements,
            representations, and understandings relating to the subject matter
            herein.
          </p>

          <h2>20. Contact Us</h2>
          <p>
            If you have any questions, concerns, or requests regarding these
            Terms and Conditions, please contact us:
          </p>
          <ul>
            <li>
              <strong>Email:</strong> contact@cousync.com
            </li>
            <li>
              <strong>Organization:</strong> CouSync LLC
            </li>
            <li>
              <strong>App Name:</strong> Status Saver – Status Saver
              &amp; Downloader
            </li>
            <li>
              <strong>Platform:</strong> Google Play Store (Android)
            </li>
          </ul>
          <p>We aim to respond to all inquiries within 30 days.</p>
        </div>

        <footer className="privacy-footer">
          All rights reserved © 2026 CouSync LLC
        </footer>
      </div>
    </>
  );
};

export default Terms;
